import { Link } from 'react-router-dom';

interface CategoryEntryProps {
  to: string;
  title: string;
  subtitle: string;
  image: string;
  count: number;
  icon: string;
}

export default function CategoryEntry({ to, title, subtitle, image, count, icon }: CategoryEntryProps) {
  return (
    <Link
      to={to}
      className="group relative flex h-[190px] cursor-pointer items-end overflow-hidden rounded-lg border border-background-200 bg-primary-900 p-5 md:h-[210px] md:p-6"
    >
      <img
        src={image}
        alt={`${title}分类入口`}
        title={`${title} - 分类影视资源`}
        className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/75 to-primary-950/35" />

      <div className="relative w-full">
        <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-primary-950">
          <i className={`${icon} text-xl`} />
        </span>
        <div className="flex items-end justify-between gap-3">
          <div>
            <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">{title}</h3>
            <p className="mt-1.5 text-xs text-background-200 md:text-sm">{subtitle}</p>
          </div>
          <span className="flex shrink-0 items-center gap-1 rounded-md border border-background-50/25 px-2.5 py-1 text-[11px] text-background-100">
            <i className="ri-film-line text-sm" />
            {count} 部
          </span>
        </div>
        <span className="mt-4 flex items-center gap-1 text-xs font-medium text-accent-300">
          进入分类
          <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}